module.exports = new __parcel__URL__("super_swole_squad_department_level_3.daa70383.png").toString();